<template>
  <div class="vue-wrapper-full" style="flex-wrap: wrap">
    <div class="content-container flex-row">
      <!-- Sidebar -->
      <div class="sidebar white left fixed" :class="sidebarVisibleClass">
        <div class="fixed-container">
          <a href="javascript:;" @click="toggleSidebar" class="sidebar-minimized-button table-overlay-close">
            <span class="button-arrow"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-small"></use></svg></span>
            <span class="glyph"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-filter"></use></svg></span>
          </a>

          <div class="sidebar-content-container small-padding custom-scrollbar">
            <TheSidebarModule
              v-if="selected.obj"
              v-on:prev="onPrev"
              v-on:next="onNext"
              v-on:on-save="onSave"
              v-on:on-delete="onDelete"
              :item="selected"
              :expertsList="experts"
            />
            <TheEmptyList v-else :title="'Velg auksjonskode og klikk søk.'" :message="'Velg deretter objektet i listen der du ønsker å legge inn et telefonbud.'" :large="false" :icon="'button-glyph-object'"/>
          </div>
        </div>
      </div>
      <!-- // Sidebar -->

      <!-- Objekt list -->
      <div class="content-container flex-row">
        <div class="content-container flex-column">
          <div id="scroll-container" class="content-container gray flex-row content-x-scroll content-y-scroll small-toolbar">
            <!-- Pagination -->
            <div class="pagination-loader-container">
              <div class="pagination-loader">
                <span class="results">Viser <strong>{{this.current.length | thousands}}</strong> av {{hits | thousands}} treff</span>

                <a href="javascript:;" v-if="loading" class="button primary tiny loading">Last flere <span class="loader-spinner"></span></a>
                <a href="javascript:;" v-else-if="this.current.length < 1" class="button primary tiny disabled">Last flere</a>
                <a href="javascript:;" v-else-if="this.current.length < hits" @click="more()" class="button primary tiny">Last flere</a>
                <a href="javascript:;" v-else-if="this.current.length >= hits" class="button primary tiny disabled">Last flere</a>

                <a href="javascript:;" @click="scrollToTop()" title="Scroll til toppen" class="button tiny scrolltop"><svg width="16px" height="16px" viewBox="0 0 16 16"><use xlink:href="/static/sprites.svg#button-glyph-arrow-left"></use></svg></a>
              </div>
            </div>
            <!-- // Pagination -->

            <table class="large fixed sortable clickable sticky-table-header compressed color-rows" :class="[selectedImageSize.key || 'c-image-small']" style="height: 0">
              <thead>
                <tr class="header">
                  <th v-for="(col, index) in columns" :key="col.key + '_' + index" class="handle" :class="col.class" @click="sortColumn(col, index)">
                    {{col.name}}
                    <span id="sorttable_sortfwdind" v-if="sort === col.sortKey && dir === 'ASC'" class="sort-on">&nbsp;</span>
                    <span id="sorttable_sortrevind" v-else-if="sort === col.sortKey && dir === 'DESC'" class="sort-on">&nbsp;</span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, trindex) in list" :key="trindex" :class="[hasSelectedObjekt(row) ? 'color-row-active' : '', row.cls]" @click="setSelectedObjekt(row)">
                  <template v-for="(col, tdindex) in row.row">
                    <td v-if="col.image" :key="trindex + '.' + tdindex" :class="col.class">
                      <img v-if="selectedImageSize.key !== 'c-image-none'" :class="{'hi-trigger': col.large}" :src="col.value" :data-hi-src-full="col.large" data-hi-size="large" />
                    </td>
                    <td v-else-if="col.tooltip" :key="trindex + '.' + tdindex" :class="col.class" v-tippy :content="col.tooltip">{{col.value}}</td>
                    <td v-else :key="trindex + '.' + tdindex" :class="col.class">
                      <span v-if="tdindex === 0 && row.child">&nbsp;</span>
                      <span v-else>{{col.value}}</span>
                    </td>
                  </template>
                </tr>
                <template v-if="searchDone">
                  <tr v-if="list.length < 1"><td colspan="30" style="text-align: left;">Fant ingen objekter...</td></tr>
                </template>
              </tbody>
            </table>

          </div>
        </div>
      </div>
      <!-- // Objekt list -->
    </div>
  </div>
</template>

<script>
import BrukerService from '@/services/BrukerService'
import ObjektService from '@/services/ObjektService'
import TheSidebarModule from './TheSidebarModule'
import bus from '@/plugins/event-bus'
import Papa from 'papaparse'
import moment from 'moment'
import fileDownload from 'js-file-download'

export default {
  name: 'Telefonbud',
  components: {
    TheSidebarModule
  },
  data () {
    return {
      showSidebar: false,
      loading: false,
      code: null,
      hits: 0,
      page: 1,
      pages: 1,
      last: null,
      list: [],
      info: {},
      listLength: 0,
      current: [],
      selected: {},
      searchDone: false,
      sort: 'Katalognr',
      dir: 'ASC',
      experts: []
    }
  },
  computed: {
    title: function () {
      return this.$route.meta.title || 'Telefonbud'
    },
    columns: function () {
      // Should handle sorting
      const cols = this.$store.getters['telefonbud/columns']

      return cols.filter(c => c.selected)
    },
    selectedImageSize: function () {
      return this.$store.getters['telefonbud/selectedImageSize']
    },
    sidebarVisibleClass: function () {
      return this.showSidebar ? 'minimizable' : 'minimized'
    }
  },
  beforeDestroy () {
    window.jQuery('body').removeClass('show-sidebar-xxlarge')
  },
  created () {
    window.jQuery('body').addClass('show-sidebar-xxlarge')

    this.showSidebar = localStorage.getItem('telefonbud-sidebar')

    bus.$off('telefonbud-reset')
    bus.$off('telefonbud-start')
    bus.$off('telefonbud-after-column-update')
    bus.$off('telefonbud-export')

    this.fetchSettings()
  },
  mounted () {
    bus.$on('telefonbud-reset', () => this.onReset())
    bus.$on('telefonbud-start', (data) => this.onSearch(data))
    bus.$on('telefonbud-after-column-update', () => this.onAfterColumnUpdate())
    bus.$on('telefonbud-export', () => this.onExportResults())
  },
  methods: {
    onReset: function () {
      this.loading = false
      this.code = null
      this.hits = 0
      this.page = 1
      this.pages = 1
      this.last = null
      this.list = []
      this.info = {}
      this.listLength = 0
      this.current = []
      this.selected = {}
      this.searchDone = false
      this.sort = 'Katalognr'
      this.dir = 'ASC'
    },
    fetchSettings: function () {
      // Also fetch lagerleie from vare.
      BrukerService.experts()
        .then((response) => {
          this.experts = response.data
        })
        .catch(() => {
          // Skip error
          this.$helpers.showErrorAlert('Feil', 'Kunne ikke laste ned eksperter')
        })
    },
    onSave: function (data) {
      console.log('After save triggered')
      console.log('data', data)
      const Objektid = data.objekt ? data.objekt.Objektid : null

      // Find item in current list
      const cindex = this.current.findIndex(o => o.Objektid === Objektid)

      if (cindex === -1) {
        // No item found in current list
        return
      }

      const obj = this.current[cindex]
      if (!obj.telefonbud) {
        obj.telefonbud = []
      }

      const tindex = obj.telefonbud.findIndex(tfb => tfb.Telefonbudid === data.Telefonbudid)
      if (tindex !== -1) {
        this.$set(obj.telefonbud, tindex, data)
      } else {
        obj.telefonbud.push(data)
      }

      // Sort list first
      const sorted = obj.telefonbud.sort((a, b) => {
        return b.Spadenr - a.Spadenr
      })

      // And update with sorted
      this.$set(obj, 'telefonbud', sorted)

      // Update the whole current list
      this.$set(this.current, cindex, obj)

      // Now rearrange the data again
      this.rearrange(this.current, 0)
        .then((parsed) => {
          this.list = parsed.list
          this.last = parsed.last
          this.info = parsed.info

          // Recalc index
          const newListIndex = this.list.findIndex(o => {
            return o.Objektid === Objektid && o.Telefonbudid === data.Telefonbudid
          })

          if (newListIndex === -1) {
            this.selected = {}
          } else {
            this.selected = {
              idx: this.list[newListIndex].idx,
              obj: this.info[this.list[newListIndex].idx]
            }
          }

          console.log(this.selected)
        })
    },
    onDelete: function (data) {
      // Find object in current and remove the forhandbud in that item
      const cindex = this.current.findIndex(o => o.Objektid === data.Objektid)

      if (cindex !== -1) {
        const obj = this.current[cindex]

        // We have telefonbud, as we should...
        if (obj.telefonbud) {
          const rindex = obj.telefonbud.findIndex(tfb => tfb.Telefonbudid === data.Telefonbudid)
          if (rindex !== -1) {
            obj.telefonbud.splice(rindex, 1)
          }
        }

        // Update current at cindex with the updated object
        this.$set(this.current, cindex, obj)

        // Now rearrange the data again
        this.rearrange(this.current, 0)
          .then((parsed) => {
            this.list = parsed.list
            this.last = parsed.last
            this.info = parsed.info

            this.onPrev()
          })
      }
    },
    onPrev: function () {
      if (this.selected.obj) {
        try {
          const next = this.selected.idx - 1
          const data = this.info[next] || null

          if (!data) {
            this.selected = {}
          } else {
            this.selected = {
              idx: next,
              obj: data
            }
          }
        } catch (e) {
          console.log('Failed to go to prev item')
          console.log(e)
        }
      }
    },
    onNext: function () {
      if (this.selected.obj) {
        try {
          const next = this.selected.idx + 1
          const data = this.info[next] || null

          if (!data) {
            this.selected = {}
          } else {
            this.selected = {
              idx: next,
              obj: data
            }
          }
        } catch (e) {
          console.log('Failed to go to next item')
          console.log(e)
        }
      }
    },
    setSelectedObjekt: function (row) {
      if (row === null) {
        this.selected = {}
      } else {
        const data = this.info.hasOwnProperty(row.idx) ? this.info[row.idx] : {}

        if (this.selected.idx !== row.idx) {
          this.selected = {
            idx: row.idx,
            obj: data
          }
        } else {
          this.selected = {}
        }
      }
    },
    hasSelectedObjekt: function (row) {
      if (this.selected.idx === null) {
        return false
      }

      return this.selected.idx === row.idx
    },
    toggleSidebar: function () {
      this.showSidebar = !this.showSidebar

      if (this.showSidebar) {
        localStorage.setItem('telefonbud-sidebar', 1)
      } else {
        localStorage.removeItem('telefonbud-sidebar')
      }
    },
    scrollToTop: function () {
      window.jQuery('#scroll-container').scrollTop(0)
    },
    sortColumn: function (column, index) {
      if (!column.sortKey) {
        // Not sortable
        return
      }

      if (column.sortKey === this.sort) {
        this.dir = this.dir === 'ASC' ? 'DESC' : 'ASC'
      } else {
        this.sort = column.sortKey
        this.dir = 'ASC'
      }

      this.page = 1
      this.search()
    },
    more () {
      if (this.page < this.pages) {
        ++this.page

        this.search()
      }
    },
    onAfterColumnUpdate: function () {
      this.rearrange(this.current, 0)
        .then((parsed) => {
          this.list = parsed.list
          this.last = parsed.last
          this.info = parsed.info
        })
    },
    onSearch: function (data) {
      this.code = data.code || null

      if (this.code) {
        this.search()
      }
    },
    search: function () {
      if (this.loading) {
        console.log('Already searching, so skip...')
        return
      }

      this.setSelectedObjekt(null)
      this.searchDone = false
      this.loading = true

      const post = {
        auction: this.code
      }

      const queryParams = {
        page: this.page || 1,
        sort: this.sort || 'Katalognr',
        direction: this.dir || 'ASC',
        limit: 500
      }

      console.log('*** Search with:', post, queryParams)
      ObjektService.getTelefonbudList(post, queryParams)
        .then(response => {
          if (this.page <= 1) {
            this.current = response.data
          } else {
            this.current = [...this.current, ...response.data]
          }

          this.rearrange(response.data, this.list.length || 0)
            .then((parsed) => {
              if (this.page <= 1) {
                this.list = parsed.list
                this.info = parsed.info
              } else {
                this.list = [...this.list, ...parsed.list]
                this.info = Object.assign({}, this.info, parsed.info)
              }

              this.last = parsed.last

              this.pages = response.headers['x-paging-pagecount'] ? parseInt(response.headers['x-paging-pagecount']) : 1
              this.hits = response.headers['x-paging-count'] ? parseInt(response.headers['x-paging-count']) : 0
            })
        })
        .catch(error => {
          console.log('*** Search error')
          console.log(error)
        })
        .then(() => {
          this.loading = false
        })
    },
    rearrange: function (data, indexStartAt = 0) {
      return new Promise((resolve, reject) => {
        const defaultThumbnail = '/static/img/object.svg'

        const retval = {
          list: [],
          info: [],
          last: null
        }

        const all = []
        data.forEach(obj => {
          if (!Array.isArray(obj.telefonbud) || obj.telefonbud.length < 1) {
            obj.telefonbud = null
          }

          all.push(obj)

          if (obj.telefonbud) {
            obj.telefonbud.forEach(tfb => {
              if (!tfb.bruker) {
                tfb.bruker = {}
              }

              if (!tfb.bruker.full_name) {
                tfb.bruker.full_name = 'Ikke valgt'
              }

              all.push(Object.assign({}, obj, { telefonbud: tfb, isChild: true }))
            })
          }
        })

        // Parse/format/sort data
        let index = indexStartAt || 0
        all.forEach(obj => {
          const row = []
          let clsTr = 'color-row-text-gray'

          if (!obj.isChild) {
            clsTr = 'color-row-text-bold color-row-bg-white color-row-extra-padding'
          }

          this.columns.forEach(c => {
            let val = this._.get(obj, c.key, c.default)
            let clsTd = c.class

            if (c.filter && val !== c.default) {
              switch (c.filter) {
                case 'date':
                  val = this.$options.filters.avantidate(val)
                  break
                case 'datetime':
                  val = this.$options.filters.avantidatetime(val)
                  break
                case 'integer':
                  val = this.$options.filters.thousands(val)
                  break
                case 'decimal':
                  val = this.$options.filters.thousandsFloat(val)
                  break
              }
            }

            // Parse and set images
            if (c.key === 'photo_thumb') {
              let thumb = this._.get(obj, 'photos.thumb', [])[0] || null
              let large = this._.get(obj, 'photos.large', [])[0] || null

              if (thumb && !thumb.startsWith('http')) {
                thumb = process.env.VUE_APP_AVANTI_API_URL + thumb
              }

              if (large && !large.startsWith('http')) {
                large = process.env.VUE_APP_AVANTI_API_URL + large
              }

              if (thumb) {
                row.push({ value: thumb, large: large, class: clsTd, tooltip: false, image: true })
              } else {
                row.push({ value: defaultThumbnail, large: null, class: clsTd, tooltip: false, image: true })
              }
            } else {
              row.push({ value: val, class: clsTd, tooltip: c.tooltip && val !== c.default ? this.$options.filters.truncate(val, 600) : false })
            }
          })

          retval.last = obj.Objektid
          retval.info[index] = obj
          retval.list.push({
            Objektid: obj.Objektid,
            Telefonbudid: obj.telefonbud ? obj.telefonbud.Telefonbudid : null,
            child: obj.isChild,
            cls: clsTr,
            idx: index,
            row: row
          })

          ++index
        })

        resolve(retval)
      })
    },
    onExportResults: function () {
      if (!this.current || !this.current.length) {
        this.$helpers.showErrorAlert('Feil', 'Fant ingen objekter å eksportere')
        return
      }

      const data = []

      // Get all experts
      let experts = {}
      this.current.forEach(obj => {
        if (Array.isArray(obj.telefonbud) && obj.telefonbud.length > 0) {
          obj.telefonbud.forEach(tfb => {
            const name = tfb.bruker && tfb.bruker.full_name ? tfb.bruker.full_name : 'Ikke valgt'
            experts[name] = name
          })
        }
      })

      if (experts.hasOwnProperty('Ikke valgt')) {
        delete experts['Ikke valgt']
        experts = Object.values(experts)
        experts.push('Ikke valgt')
      } else {
        experts = Object.values(experts)
      }

      // Build headers
      const headers = ['Kat.nr', 'Kunstner', 'Tittel']
      experts.forEach(e => {
        headers.push(e)
      })

      // Add headers
      data.push(headers)

      // Get length of headers - used to calc pos on expert / kunde info
      const eLen = headers.length

      // Parse and build data in correkt column for each katalognr.
      this.current.forEach(obj => {
        if (Array.isArray(obj.telefonbud) && obj.telefonbud.length > 0) {
          const item = []

          // Add katnr, kunstner, tittel
          item.push(obj.Katalognr)
          item.push(obj.kunstner ? obj.kunstner.Navn : '-')
          item.push(obj.Katalogtekst1)

          // Loop all tfn bids
          obj.telefonbud.forEach(tfb => {
            const name = tfb.bruker && tfb.bruker.full_name ? tfb.bruker.full_name : 'Ikke valgt'
            const eidx = headers.findIndex(e => e === name)

            // Add name kundeinfo on correct position (i.e. for correct expert)
            for (let i = 3; i < eLen; ++i) {
              if (i === eidx) {
                const info = []

                info.push(tfb.Spadenr || '')
                info.push(tfb.kunde ? tfb.kunde.parsed_name : '')

                if (tfb.Merknad) {
                  info.push(tfb.Merknad)
                }

                item[i] = info.join(' - ')
              } else if (!item[i]) {
                // Only set empty if not already have a value
                item[i] = ''
              }
            }
          })

          data.push(item)
        } else {
          const item = []

          item.push(obj.Katalognr)
          item.push(obj.kunstner ? obj.kunstner.Navn : '-')
          item.push(obj.Katalogtekst1)

          data.push(item)
        }
      })

      // Make csv and force download...
      const csv = '\ufeff' + Papa.unparse(data, { delimiter: ';' })
      const blob = new Blob([csv], {
        type: 'application/csvcharset=utf-8'
      })

      fileDownload(blob, 'telefonbud-' + moment().format('DDMMYYHms') + '.csv')
    }
  }
}
</script>
<style scoped>
  table td:focus {
    outline: none;
  }
  /* table tr.selected,
  table tr.selected:hover,
  table tr.selected:active,
  table tr.selected:focus {
    background: blue !important;
  } */
</style>



// WEBPACK FOOTER //
// src/components/Admin/Auctions/Telefonbud/Telefonbud.vue